<template>
  <el-input :value="coordinateText" v-bind="$attrs" v-on="inputListeners" />
</template>

<script>
import { formatLonLat, parseLonLat, gcj02PointToWgs84LonLat, wgs84LonLatToGcj02Point } from './coordinate'

export default {
  name: 'CoordinateInput',
  inheritAttrs: false,
  props: { value: { type: String, default: '' } },
  data() { return { coordinateText: '', emittedValue: null } },
  computed: {
    inputListeners() {
      return { ...this.$listeners, input: this.onInput, change: this.onChange, blur: this.onBlur }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        // 自己输入产生的模型更新不重新格式化，避免逐键转换打断输入。
        if (value !== this.emittedValue) this.coordinateText = formatLonLat(wgs84LonLatToGcj02Point(value))
      }
    }
  },
  methods: {
    onInput(value) {
      this.coordinateText = value
      const point = parseLonLat(value)
      const displayValue = formatLonLat(wgs84LonLatToGcj02Point(this.value))
      this.emittedValue = point && formatLonLat(point) === displayValue ? this.value : (point ? gcj02PointToWgs84LonLat(point[0], point[1]) : '')
      this.$emit('input', this.emittedValue)
    },
    onChange() { this.$emit('change', this.emittedValue) },
    onBlur(event) {
      if (!parseLonLat(this.coordinateText)) this.coordinateText = ''
      this.$emit('blur', event)
    }
  }
}
</script>
